import { createRoute } from '@tanstack/react-router';
import { Route as authenticatedRoute } from './route';
import SearchPage from '@/features/search/pages/SearchPage';

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/search',
  validateSearch: (search) => {
    return {
      q: search.q as string || '',
    };
  },
  component: SearchPage,
});

export default Route;
